import * as React from 'react';

import {
  NotificationModal,
  useOpenNotificationModal
} from 'catering/components/Modals';
import { PrimaryCta } from 'components/Buttons';

function CartItemsExpiredNotification() {
  // TODO: missing implementation
  const handlePrimaryCtaClick = () => {
    window.alert('Empty Cart');
  };

  return (
    <NotificationModal
      title="Uh oh! That's not an option"
      text="The items already in your cart are currently unavailable.
        You can continue by emptying your cart to start a new order."
    >
      <PrimaryCta
        label="Yes, empty my cart"
        handleClick={handlePrimaryCtaClick}
        fullWidth
      />
    </NotificationModal>
  );
}

export function useOpenCartItemsExpiredNotificationModal() {
  return useOpenNotificationModal(<CartItemsExpiredNotification />);
}
